import * as React from 'react';
import { noopLogger } from './noop-logger.js';

/**
 * React Context for logger
 *
 * @type {React.Context}
 * @access private
 */

var LoggerContext = /*#__PURE__*/React.createContext(noopLogger);

export { LoggerContext };
